import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import Preview from '../../components/preview/preview.jsx';
import Services from '../../components/services/services.jsx';
import { apiFetch } from '../../utils/api.js';

export const Home = () => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  // SEO заголовок
  useEffect(() => { 
    document.title = "Строительные и земляные работы в Селятино | Комплекс строй"; 
  }, []);

  const fetchCards = async () => {
    try {
      setLoading(true);
      // Запрашиваем только избранные услуги прямо с бэкенда
      const response = await apiFetch('/api/cards?featured=true');
      if (response.ok) {
        const jsonData = await response.json(); 
        setCards(jsonData);
      }
    } catch (err) {
      console.error("Ошибка загрузки услуг:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCards();
  }, []);

  return (
    <>
      <Preview />
      {loading ? (
        <div className="d-flex justify-content-center py-5 bg-white">
          <Spinner animation="border" style={{ color: 'var(--corp-accent)' }} />
        </div>
      ) : (
        <Services cards={cards} />
      )}
    </>
  );
}
